/* eslint-disable */
/* eslint-disable no-unused-vars */
import React, { useMemo } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
//utils
import { imageAPI, portalWWW } from "../../../utils/constants";

const breakpoints = {
  names: ["xs", "sm", "md", "lg"],
  mediaQueries: {
    xs: 576,
    sm: 768,
    md: 992,
    lg: 1200
  },
  sizes: {
    lg: {
      xs: 768,
      sm: 992,
      md: 1200,
      lg: 1920
    },
    md: {
      xs: 576,
      sm: 768,
      md: 992,
      lg: 1200
    },
    sm: {
      xs: 432,
      sm: 576,
      md: 768,
      lg: 992
    },
    xs: {
      xs: 324,
      sm: 432,
      md: 576,
      lg: 768
    }
  }
};

function Picture({
  src,
  isLocal,
  isVector,
  className,
  alt,
  size,
  useHeight,
  absoluteSize,
  ...props
}) {
  const { names, mediaQueries, sizes } = breakpoints;
  const rest = Object.assign({}, props);
  delete rest.backgroundSize;
  delete rest.imagePosition;
  delete rest.backgroundColor;

  const onHandleSrc = size => {
    const param = useHeight ? "height" : "width";

    //A external image
    if (
      (src !== undefined && src !== null && src.includes("http")) ||
      src.includes("data:image")
    ) {
      return src;
    }

    return `${imageAPI}/image/resizer?imageUrl=${portalWWW}/${encodeURIComponent(
      src
    )}&${param}=${size}`;
  };

  // When the absoluteSize prop is defined it uses that size for the image query
  const isAbsolute = useMemo(() => !!absoluteSize, [absoluteSize]);
  const defaultSrc = useMemo(() => {
    if (!isAbsolute) return onHandleSrc(sizes[size].lg);
    return onHandleSrc(absoluteSize);
  }, [isAbsolute, src]);

  return (
    <div className={className}>
      <picture>
        {!isAbsolute &&
          breakpoints.names.map(breakpoint => (
            <source
              key={breakpoint}
              media={`(max-width: ${breakpoints.mediaQueries[breakpoint]}px)`}
              srcSet={onHandleSrc(sizes[size][breakpoint])}
              {...rest}
            />
          ))}
        <img src={defaultSrc} alt={alt} {...rest} />
      </picture>
    </div>
  );
}

Picture.defaultProps = {
  isLocal: true,
  isVector: false,
  backgroundColor: "transparent",
  backgroundSize: "fill",
  imagePosition: "center",
  size: "md",
  useHeight: false,
  absoluteSize: null
};

Picture.propTypes = {
  src: PropTypes.string.isRequired,
  isLocal: PropTypes.bool,
  isVector: PropTypes.bool,
  alt: PropTypes.string.isRequired,
  imagePosition: PropTypes.string,
  size: PropTypes.oneOf(["xs", "sm", "md", "lg"]),
  useHeight: PropTypes.bool,
  absoluteSize: PropTypes.string
};

export default styled(Picture)`
  /* Without line height 0 there be a weird white spacing below the images */
  line-height: 0;
  background: ${props => props.backgroundColor};
  img {
    object-fit: ${props => props.backgroundSize};
    object-position: ${props => props.imagePosition};
    width: 100%;
    height: ${props => props.height};
  }
  // Small devices (landscape phones, less than 768px)
  @media (max-width: 767px) {
    img {
      height: ${props => props.smHeight};
    }
  }
`;
